import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Card, Col, Container, Row, Form, Button, Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import TableContainer from "Common/TableContainer";
import 'react-toastify/dist/ReactToastify.css';
import {DeleteModal} from "Common/DeleteModal";
import {
    getModelList as onGetModelList,
    addModelList as onAddModelList,
    updateModelList as onUpdateModelList,
    deleteModelList as onDeleteModelList
} from "slices/model/thunk";
import {searchModelList} from "helpers/helper";
import {useDispatch, useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import {createSelector} from "reselect";
import {useFormik} from "formik";
import * as Yup from "yup";

const ModelList = () => {

    document.title = "Model list";
    const dispatch = useDispatch<any>();

    const selectModelList = createSelector(
        (state: any) => state.Model,
        (model) => ({
            modelList: model.modelList
        })
    );

    const {modelList} = useSelector(selectModelList);
    console.log(modelList)
    useEffect(() => {
        dispatch(onGetModelList());
    }, [dispatch]);

    const [listView, setListView] = useState<any>([]);
    const [modelLists, setModelLists] = useState<any>(null);
    const [addModel, setAddModel] = useState<boolean>(false);
    const [editModel, setEditModel] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [edit, setEdit] = useState<any>();
    //add
    const handleCloseModel = () => {
        setAddModel(false);
    }
    const handleShowModel = () => setAddModel(true);
    //edit
    const handleEdit = useCallback((item: any) => {
        const lastItem = item.row.original
        setAddModel(true);
        setEditModel(true);
        setEdit({
            id: lastItem.id,
            model: lastItem.name,
            code: lastItem.code
        });
        console.log(lastItem)

    }, []);

    //search
    const handleChange = async (ele: any) => {
        const search = ele.target.value;
        if (search) {
            try {
                const response: any = await searchModelList({keyword: search}, {page: 0, size: 500});
                setListView(response.content);
            } catch (error) {
                setListView([]);
            }
        } else {
            setListView(modelList.content);
        }
    };

    // delete
    const handleDeleteShow = (ele: any) => {
        setShow(true);
        setModelLists(ele);
    };

    const handleDeleteClose = () => {
        setShow(false);
    }

    //delete modal
    const deleteModalFunction = () => {
        const deleteData = modelLists.row.original.id || {};
        console.log(deleteData);
        if (deleteData) {
            dispatch(onDeleteModelList(deleteData));
        }
        setShow(false);
    };

    useEffect(() => {
        setListView(modelList.content);
    }, [modelList]);

    //columns
    const columns = useMemo(
        () => [
            {
                header: (
                    <Form.Check>
                        <Form.Check.Input type="checkbox" value="option" id="checkAll"/>
                        <Form.Check.Label htmlFor="checkAll"></Form.Check.Label>
                    </Form.Check>
                ),
                cell: (cell: any) => {
                    return (
                        <Form.Check className="checkbox-product-list">
                            <Form.Check.Input type="checkbox" value="2" id="checkbox-2"/>
                            <Form.Check.Label htmlFor="checkbox-2"></Form.Check.Label>
                        </Form.Check>
                    );
                },
                id: "#",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "№",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.index + 1}</span>
                    )
                }
            },
            {
                header: "Model name",
                accessorKey: "productName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Model code",
                accessorKey: "code",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Created At",
                accessorKey: "createdAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Updated At",
                accessorKey: "updatedAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <ul className="d-flex gap-2 list-unstyled mb-0">
                            <li>
                                <Link to="#" className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                      onClick={() => handleEdit(cell)}><i className="ph-pencil"></i></Link>
                            </li>
                            <li className={"mx-2"}>
                                <Link to="#" className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                      onClick={() => handleDeleteShow(cell)}><i className="ph-trash"></i></Link>
                            </li>
                        </ul>
                    );
                }
            },
        ], []
    );

    // validation
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            model: (edit && edit.model) || '',
            code: (edit && edit.code) || '',
            id: edit && edit.id,
        },
        validationSchema: Yup.object({
            model: Yup.string().required("Please Enter Your Model"),
            code: Yup.string().required("Please Enter Your Code"),
        }),

        onSubmit: (values: any) => {

            if (editModel) {
                const data: any = {
                    productName: values.model,
                    code: values.code,
                    id: values.id
                }
                dispatch(onUpdateModelList(data));
                formik.resetForm();
            } else {
                const data: any = {
                    productName: values.model,
                    code: values.code,
                }

                dispatch(onAddModelList(data));
                formik.resetForm();
            }
            if (values === null) {
                handleShowModel();
            } else {
                setEdit(null);
                setEditModel(false);
                handleCloseModel();
            }
        }
    });


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row id="modelList">
                        <Col lg={12}>
                            <Card>
                                <Card.Header>
                                    <Row className="align-items-center g-2">
                                        <Col lg={3} className="me-auto">
                                            <h6 className="card-title mb-0">Model List</h6>
                                        </Col>
                                        <Col xl={2} md={3}>
                                            <div className="search-box">
                                                <Form.Control
                                                    type="text" className="search"
                                                    placeholder="Search model..."
                                                    onChange={(e: any) => handleChange(e)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="hstack gap-2">
                                                <Button className="btn btn-subtle-danger d-none" id="remove-actions">
                                                    <i className="ri-delete-bin-2-line"></i>
                                                </Button>
                                                <Button variant="secondary" onClick={handleShowModel}>
                                                    <i className="bi bi-plus-circle align-baseline me-1"></i> Add
                                                    Model
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body className="mt-3">
                                    {
                                        listView && listView.length > 0 ?
                                            <TableContainer
                                                isPagination={true}
                                                columns={columns}
                                                data={listView || []}
                                                customPageSize={10}
                                                divClassName="table-responsive table-card"
                                                tableClass="table table-centered align-middle table-custom-effect table-nowrap mb-0"
                                                theadClass="table-light"
                                                PaginationClassName="align-items-center mt-4 pt-3"
                                                isBordered={false}
                                            />
                                            :
                                            <div id="noresult">
                                                <div className="text-center py-4">
                                                    <div className="avatar-md mx-auto mb-4">
                                                        <div
                                                            className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                            <i className="bi bi-search"></i>
                                                        </div>
                                                    </div>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                </div>
                                            </div>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>

            <Modal show={addModel} onHide={handleCloseModel}>
                <Modal.Header closeButton>
                    <Modal.Title>{editModel ? "update Model List" : "Add Model"}</Modal.Title>
                </Modal.Header>
                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="mb-3">
                            <Form.Label htmlFor="Customer-Name-input">Model Name<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="Customer-Name-input"
                                name="model"
                                placeholder="Model Name"
                                value={formik.values.model}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.model}
                            />
                            {formik.errors.faculty && formik.touched.model ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.model}</Form.Control.Feedback>
                            ) : null}
                        </div>
                        <div className="mb-3">
                            <Form.Label htmlFor="code">Code<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="code"
                                name="code"
                                placeholder="Model Code"
                                value={formik.values.code}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.code}
                            />
                            {formik.errors.faculty && formik.touched.model ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.code}</Form.Control.Feedback>
                            ) : null}
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseModel}>
                            <i className="bi bi-x-lg align-baseline me-1"></i> Close
                        </Button>
                        <Button type="submit" variant="primary"
                                id="add-btn">{editModel ? "update" : "Add Model"}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <ToastContainer/>
        </React.Fragment>
    );
};

export default ModelList;